import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { UserProfileSelectors } from '@gestor-web/@core/store/selectors';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { filter, map, skipWhile, switchMap, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ProfileGuard {
  constructor(
    private store: Store,
    private router: Router,
  ) {}

  /**
   * Perfil completo libera a rota depois que a lista de funcionalidades do login chega (ela é
   * pedida junto com o perfil). Fora do workspace nada mais a espera, e a tela que abria antes
   * montava o grid sem opções: o AG Grid só lê o `gridOptions` na inicialização. Se a lista não
   * vem (timeout ou erro do servidor, ver `CARREGAMENTO_TIMEOUT_MS`), o destino é `/offline`.
   */
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.store.select(UserProfileSelectors.selectUserProfile).pipe(
      skipWhile(({ kc_loaded, idss_loaded }) => !kc_loaded || !idss_loaded),
      // tap(_ => console.log('[Profile::Guard] check', _)),
      take(1),
      switchMap(({ idss, isIncomplete, isOffline }) => {
        // console.log('[Profile::Guard] idss', idss, 'isIncomplete', isIncomplete, 'isOffline', isOffline);
        if (idss && !isIncomplete && !isOffline) {
          // console.log('[Profile::Guard] ok...');
          return this.store.select(UserProfileSelectors.selectUserProfile).pipe(
            filter(({ funcionalidades_loaded }) => funcionalidades_loaded),
            take(1),
            map(({ isOffline }) => (isOffline ? this.router.createUrlTree(['/offline']) : true)),
          );
        }
        const path = state.url.split('?')[0];
        const action = route.queryParams.action;
        if (isOffline) {
          if (path != '/offline') {
            // console.log('[Profile::Guard] redirect - offline');
            return of(this.router.createUrlTree(['/offline']));
          }
        }
        if (isIncomplete) {
          if (path != '/profile' || action != 'completar-cadastro') {
            // console.log('[Profile::Guard] redirect - completar');
            return of(this.router.createUrlTree(['/profile'], { queryParams: { action: 'completar-cadastro' } }));
          }
        }
        return of(true);
      }),
    );
  }
}
